import { css } from '@emotion/css';
import { isActive, navItemLink } from 'Shared/frontend/nav/MobileFooterNav';
import { theme, useSettings } from 'Shared/frontend/SettingsProvider';
import { createMemo, For, Show, Switch} from 'solid-js';
import { SubNav } from 'Shared/frontend/nav/SubNav';
import { Match } from 'solid-js';
import { ImageDetails } from 'Shared/model/basic';
import { useUrls } from 'Shared/SiteProvider';

/*
	XXX current a max-width is set across the the entire nav. A more robust approach is probably
	    to work up from the buttons. calc-size() and max-content could be used for this, but not super
		well supported yet.
*/

const buttonStyle = () => css({
	...theme().nav.desktop.settings.button,

	':hover': theme().nav.desktop.settings.hover
});


export function NavWidgetContents(P:{logo?:ImageDetails})
{
	const putLogoInCenter = () => theme().nav.desktop.settings.logoPosition == 'center';

	const logoUrl = () => {
		if (!P.logo?.hash) return '';
		return useUrls().createImageUrl(P.logo.hash,P.logo,'Venue-logo','full');
	};

	const parts = createMemo(() => {
		/* Odd numbers? Extra item gets added to the start */
		const items = useSettings().navContent().desktop;
		const halfWay = Math.ceil(items.length / 2);
		return {head:items.slice(0,halfWay), tail: items.slice(halfWay)};
	});

	const logoStyle = css(
		{ height: '100%' },
		theme().nav.desktop.settings.logo
	); 

	return (
		<Switch>
			<Match when={putLogoInCenter()}>
				<NavItems items={parts().head} />
				<img class={logoStyle} src={logoUrl()} />
				<NavItems items={parts().tail} />
			</Match>
			<Match when={true}>
				<NavItems items={useSettings().navContent().desktop} />
			</Match>
		</Switch>
	);
}

function NavItems(P:{items})
{
	//XXX do we really need to 2 uses of hoverStyle?
	const hoverStyle = css({
		'&:hover .subnav': {
			display: 'block'
		}
	});

	return (
		<For each={P.items}>{ item => <>
			<div classList={{[hoverStyle]: item.items}}>
				<a href={navItemLink(item)}>
					<button tabindex='-1'
						classList={{
							[buttonStyle()]: true,
							[css(theme().nav.desktop.settings.active)]: isActive(item)
						}}
					>
						{item.label}
					</button>
				</a>

				<Show when={item.items}>
					<SubNav item={item} />
				</Show>
			</div>
		</>}</For>
	);
}

